// extracted by mini-css-extract-plugin
export default {"wrapper":"Comics_wrapper__N7Bme","title":"Comics_title__HSQOp","see-more":"Comics_see-more__j5WW5","delete-all":"Comics_delete-all__HQQ5A","list":"Comics_list__01QBf"};